import store from '@/store';
export const CustomLMRAListStorageKey = "CUSTOM-THREE-STATE-LMRA-LIST";

export const CustomLmraListsHelper = {
    isValidThreeStateQuestionListObject(data){
        /*window.console.log('revalidating the object');
        window.console.log(data);*/

        if (data.key === undefined || data.custom_lmra_questions === undefined) {
            return false;
        }
        if(data.custom_lmra_questions.length <= 0){
            return false;
        }

        return true;
    },
    async setValidatedCustomLmraList($validatedCustomLmraList){
       await store.dispatch('setCurrentCustomLmraList', $validatedCustomLmraList);
    },
    async getCurrentValidatedCustomLmraList(){
        return await store.getters.getCurrentValidatedCustomLmraList;
    }
}